import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { employerJobCreationStepsSingle } from '../../../../constants/jobs';
import { monthDayYearWithSlashFormat } from '../../../../constants/date';
import { getTimeInfoUi, getJobTimeDurationUi } from '../../../../helpers/jobs';
import Loader from '../../../common/ui/Loader';

export default class Summary extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    skillLabel: PropTypes.string.isRequired,
    workersQuantity: PropTypes.number.isRequired,
    estCost: PropTypes.string.isRequired,
    locationLabel: PropTypes.string.isRequired,
    startDate: PropTypes.object.isRequired,
    startTime: PropTypes.object.isRequired,
    endTime: PropTypes.object.isRequired,
    actualHours: PropTypes.number.isRequired,
    dressCodeLabel: PropTypes.string.isRequired,
    dressCodeInstructions: PropTypes.string.isRequired,
    jobDescription: PropTypes.string.isRequired,
    whereToReport: PropTypes.string.isRequired,
    goToStep: PropTypes.func.isRequired,
    saveJob: PropTypes.func.isRequired,
    postJobToBoard: PropTypes.func.isRequired,
    letChooseWorker: PropTypes.func.isRequired
  };

  render () {
    const { skillLabel, workersQuantity, estCost, locationLabel, startDate, startTime, endTime, actualHours,
      dressCodeLabel, dressCodeInstructions, jobDescription, whereToReport, goToStep, saveJob, postJobToBoard,
      letChooseWorker, isLoading } = this.props;
    return (
      <React.Fragment>
        { isLoading ? <Loader /> : (
          <React.Fragment>
            <section className='job-posting-section almost-done-section'>
              <h4>Almost Done</h4>
              <p className='info-text'>Are you ready to find workers for this job? If so, how do you want to find them?</p>
              <button
                className='gravy-button info-btn'
                onClick={postJobToBoard}
              >
                Post To Job Board
              </button>
              <button
                className='gravy-button info-btn'
                onClick={letChooseWorker}
              >
                Let Me Choose Worker
              </button>
              <p className='not-yet-text'>Not yet?</p>
              <button
                className='gravy-button info-btn'
                onClick={saveJob}
              >
                Save as Draft
              </button>
            </section>
            <section className='job-posting-section summary-section'>
              <header><h4>Summary</h4></header>
              <div className='flex-wrapper'>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Job:</p></h5>
                  <p>{skillLabel}</p>
                </div>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Workers Needed:</p></h5>
                  <p>{workersQuantity}</p>
                </div>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Estimate Pay:</p></h5>
                  <p>{estCost}</p>
                </div>
              </div>
              <h5 className='separated'><p className='sub-header'>Job Location:</p></h5>
              <p>{locationLabel}</p>
              <div className='flex-wrapper'>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Start Date:</p></h5>
                  <p>{moment(startDate).format(monthDayYearWithSlashFormat)}</p>
                </div>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Time:</p></h5>
                  <p>{getTimeInfoUi(startTime, endTime)}</p>
                </div>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Hours:</p></h5>
                  <p>{getJobTimeDurationUi(actualHours)}</p>
                </div>
              </div>
              <div className='flex-wrapper'>
                <div className='summary-item-wrapper'>
                  <h5><p className='sub-header'>Dress Code:</p></h5>
                  <p>{dressCodeLabel}</p>
                </div>
                { dressCodeInstructions && (
                  <div className='summary-item-wrapper'>
                    <h5><p className='sub-header'>Additional Instructions:</p></h5>
                    <p>{dressCodeInstructions}</p>
                  </div>
                )}
              </div>
              <h5 className='separated'><p className='sub-header'>Description:</p></h5>
              <p>{jobDescription}</p>
              { whereToReport && (
                <React.Fragment>
                  <h5><p className='sub-header'>Additional Instructions:</p></h5>
                  <p>{whereToReport}</p>
                </React.Fragment>
              )}
            </section>
            <div className='nav-buttons-wrapper'>
              <button
                className='gravy-button back-step-button'
                onClick={() => goToStep(employerJobCreationStepsSingle.third.id)}
              >Back</button>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJobEmployerSingle/Summary.js